import React from "react";
import {
  DashboardOutlined,
  PrecisionManufacturingOutlined,
  WorkOutline,
  PlaylistPlay,
  AssessmentOutlined,
  VpnKeyOutlined,
  BusinessOutlined,
  SystemUpdateAltOutlined,
  ChatBubbleOutline,
  SupportAgentOutlined,
  DevicesOutlined,
  AdminPanelSettingsOutlined,
  ConfirmationNumberOutlined,
  StorefrontOutlined,
  StorageOutlined,
  ShieldOutlined,
} from "@mui/icons-material";
import { NavigationIcon as IconName } from "../utils/navigation";

const icons = {
  overview: DashboardOutlined,
  machines: PrecisionManufacturingOutlined,
  jobs: WorkOutline,
  worklists: PlaylistPlay,
  reports: AssessmentOutlined,
  licenses: VpnKeyOutlined,
  customers: BusinessOutlined,
  updates: SystemUpdateAltOutlined,
  messages: ChatBubbleOutline,
  support: SupportAgentOutlined,
  computers: DevicesOutlined,
  admin: AdminPanelSettingsOutlined,
  tokens: ConfirmationNumberOutlined,
  resellers: StorefrontOutlined,
  database: StorageOutlined,
  security: ShieldOutlined,
};
export default function NavigationIcon({ name }: { name: IconName }) {
  const Icon = icons[name];
  return <Icon sx={{ fontSize: 20 }} />;
}
